import styled from 'styled-components';

export const FooterStyles = styled.footer`
  padding: 5rem 0 2rem 0;
  text-align: center;
  background-color: var(--black-2);
  display: flex;
  flex-direction: column;
  align-items: center;

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1200px;
    width: 90%;
    margin: 0 auto;
    color: var(--white);
  }

  .footer__text {
    margin-top: 1rem;
    max-width: 400px;
    text-align: center;
    color: white;
  }

  .footer__menuList,
  .footer__socialList {
    display: flex;
    margin-top: 1.5rem;
    padding: 0;
    list-style: none;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.6rem 1.4rem;
  }

  .footer__menuList li,
  .footer__socialList li {
    margin: 0 0.5rem;
  }

  .horizontal {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    gap: 2rem;
  }

  .footer__menuList a,
  .footer__socialList a {
    color: var(--white-1);
    font-size: 1.5rem;
    text-decoration: none;
    transition: color 0.3s ease;
  }

  .footer__menuList a:hover,
  .footer__socialList a:hover {
    color: var(--white-1);
  }

  .copyright {
    margin-top: 1rem;
    color: white;
    font-size: 1.2rem;
  }

  @media only screen and (max-width: 768px) {
    padding: 3.5rem 0 1.5rem;

    .horizontal {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 1.5rem;
    }

    .footer__menuList a,
    .footer__socialList a {
      font-size: 1.4rem;
    }
  }

  @media only screen and (max-width: 480px) {
    padding: 3rem 0 1.5rem;

    .footer__menuList,
    .footer__socialList {
      gap: 0.4rem 1rem;
    }

    .footer__menuList a,
    .footer__socialList a {
      font-size: 1.3rem;
    }

    .copyright {
      font-size: 1.1rem;
    }
  }
`;
